var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ccon"},[_c('div',{attrs:{"id":"container"}}),(_vm.isShow)?_c('showImg3',{attrs:{"imgList":_vm.imgList},on:{"close":_vm.imgClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }